  function aj(data) {
    $.ajax({
      type: "GET",
      url: "https://www.minyue99.com/shopify/kovol/get-store-info",
      data: data,
      success: function(res){
        if (res.code == 200) {
          let data = res.data;
          let pData = JSON.parse(data);
          let officialOnlineStoresList = pData.officialOnlineStoresList;
          let retailStoreList = pData.retailStoreList;
          const buyBoxLineLeft = $(".box-tb_item-left .buy-box");
          const buyBoxLineRight = $(".box-tb_item-right .buy-box");
          var htmls = "";
          var htmlss = "";
//           for( let one of officialOnlineStoresList ){
//             htmls += '<div class="buy-box_line">';
//             htmls += '<div class="country">';
//             htmls += '<p>' + one.country + '</p>';
//             htmls += '</div>';
//             htmls += '<div class="link-shop">';
//             htmls += '<div class="link-shop_item">';
//             htmls += '<a href="' + one.shopUrl + '" class="link-shop_item-img" target="_blank">';
//             htmls += '<img src="' + one.logo + '" />';
//             htmls += '</a>';
//             htmls += '<div class="link-shop_item-word">' + one.platform + '</div>';
//             htmls += '</div>';
//             htmls += '</div>';
//             htmls += '</div>';
//           }
          for(i = 0; i < officialOnlineStoresList.length; i++) {
            htmls += '<div class="buy-box_line">';
            htmls += '<div class="country">';
            htmls += '<p>' + officialOnlineStoresList[i].country + '</p>';
            htmls += '</div>';
            htmls += '<div class="link-shop">';
            htmls += '<div class="link-shop_item">';
            htmls += '<a href="' + officialOnlineStoresList[i].shopUrl + '" class="link-shop_item-img" target="_blank">';
            htmls += '<img src="' + officialOnlineStoresList[i].logo + '" />';
            htmls += '</a>';
            htmls += '<div class="link-shop_item-word">' + officialOnlineStoresList[i].platform + '</div>';
            htmls += '</div>';
            htmls += '</div>';
            htmls += '</div>';
          }
          buyBoxLineLeft.html(htmls);
          for(i = 0; i < retailStoreList.length; i++) {
            htmlss += '<div class="buy-box_line">';
            htmlss += '<div class="country">';
            htmlss += '<p>' + retailStoreList[i].dealerName + '</p>';
            htmlss += '</div>';
            htmlss += '<div class="link-shop">';
            htmlss += '<div class="link-shop_item">';
            htmlss += '<a href="' + retailStoreList[i].shopUrl + '" class="link-shop_item-img" target="_blank">';
            htmlss += '<img src="' + retailStoreList[i].logo + '" />';
            htmlss += '</a>';
            htmlss += '<div class="link-shop_item-word">' + retailStoreList[i].platform + '</div>';
            htmlss += '</div>';
            htmlss += '</div>';
            htmlss += '</div>';
          }
          buyBoxLineRight.html();
        } 
      },
    })
  }
  
  
  
  function aja(datas) {
     $.ajax({
      type: "GET",
      url: "https://www.minyue99.com/shopify/kovol/get-country-by-address",
      data: datas,
      success: function(res){
        if (res.code == 200) {
          const tag = $(".regions-childe");
          let data = res.data;
          let html = "";
          for (var i = 0; i<data.length; i++) {
            html += '<option value="'+ data[i] +'"> '+ data[i] +'</option>';
          }
          tag.html('<option selected="" value="All">All</option>' + html);
        }
      },
    })
  }
